import { memo } from 'react';
import { StyledTag } from '../styled-components';
import { type StatusTagProps as Props } from './types';

export const StatusTag = memo(
  ({
    className,
    status,
    label,
    variant = 'filled',
    colorMap,
    fullWidth,
    ...other
  }: Props) => {
    const normalizedStatus = status?.toString().toUpperCase();
    const tagColor = colorMap[normalizedStatus] || 'default';

    return (
      <StyledTag
        variant={variant}
        color={tagColor}
        label={label}
        size="small"
        {...other}
        fullWidth={fullWidth}
      />
    );
  }
);

StatusTag.displayName = 'StatusTag';
